const getFormByCurrentLanguage = (selectedLanguage, form1, form2) => {
  if (selectedLanguage === 'Norway' && form2 && Object.keys(form2).length > 0) {
    return form2;
  }

  return form1;
};

export { getFormByCurrentLanguage };
